import Vue from 'vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)


// WEBPACK FOOTER //
// ./src/plugins/icons.js